import { render, staticRenderFns } from "./InformationPage.vue?vue&type=template&id=38bb66b0&scoped=true"
import script from "./InformationPage.vue?vue&type=script&lang=js"
export * from "./InformationPage.vue?vue&type=script&lang=js"
import style0 from "./InformationPage.vue?vue&type=style&index=0&id=38bb66b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bb66b0",
  null
  
)

export default component.exports